import { Box } from "@mui/material";
import React, { useEffect } from "react";
import ServerlessComputing from "./ServerlessComputing";
import Sidebar from "../UI/Sidebar/Sidebar";
import { useUserStore } from "../../store/UserStore";
import { useNavigate } from "react-router-dom";

const Layout = () => {
  const user = useUserStore((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  });
  return (
    <Box display={"flex"} gap={2} sx={{ marginTop: "60px" }}>
      <div className="app-container">
        <Sidebar />
        <ServerlessComputing />
      </div>
    </Box>
  );
};

export default Layout;
